// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#integration-drawer .header {
  padding-left: 5rem;
  padding-top: 2.5rem;
}
@media (max-width: 768px) {
  #integration-drawer .header {
    padding: 1rem;
    padding-bottom: 0;
  }
}
#integration-drawer .header .close-button {
  margin-right: 0.65rem;
}
#integration-drawer .list-container {
  padding: 0 5rem;
}
#integration-drawer .list-container .add-integration-form-left-title {
  padding: 2.5rem 0;
}
@media (max-width: 768px) {
  #integration-drawer .list-container .add-integration-form-left-title {
    padding: 2rem 0;
  }
}
@media (max-width: 768px) {
  #integration-drawer .list-container {
    padding: 0 1rem;
  }
}
#integration-drawer .carousel-content {
  overflow-y: auto;
}
#integration-drawer .slick-dots {
  display: none !important;
}
#integration-drawer .loading-redirect-screen,
#integration-drawer .loading-integration-screen {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 12.5rem;
}
@media (max-width: 768px) {
  #integration-drawer .loading-redirect-screen,
  #integration-drawer .loading-integration-screen {
    padding: 0 2rem;
  }
}
#integration-drawer .loading-redirect-screen p,
#integration-drawer .loading-integration-screen p {
  opacity: 0.5;
}
#integration-drawer .loading-redirect-screen .loading-integration-image,
#integration-drawer .loading-integration-screen .loading-integration-image {
  width: 12rem;
  margin-bottom: 3.6rem;
}
#integration-drawer .success-integration-content {
  height: 100vh;
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
}
#integration-drawer .success-integration-content .success-integration-message-container {
  margin-bottom: 96px;
}
@media (max-width: 768px) {
  #integration-drawer .success-integration-content .success-integration-message-container {
    margin-bottom: 1rem;
  }
}
#integration-drawer .success-integration-content .gyramais-integration-alert {
  margin: 0 10% 1.5625rem 10%;
  max-width: 40rem;
  text-align: center;
  background-color: #E6F7FF;
}
@media (max-width: 768px) {
  #integration-drawer .success-integration-content .gyramais-integration-alert {
    margin: 0 0 1rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/drawers/IntegrationDrawer/styles.less"],"names":[],"mappings":"AAAA;EAEI,kBAAA;EACA,mBAAA;AAAJ;AAEI;EAAA;IACE,aAAA;IACA,iBAAA;EACJ;AACF;AATA;EAWM,qBAAA;AACN;AAZA;EAgBI,eAAA;AADJ;AAfA;EAmBM,iBAAA;AADN;AAGM;EAAA;IACE,eAAA;EAAN;AACF;AAGI;EAAA;IACE,eAAA;EAAJ;AACF;AA5BA;EAgCI,gBAAA;AADJ;AA/BA;EAoCI,wBAAA;AAFJ;AAlCA;;EAyCI,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAHJ;AAKI;EAAA;;IACE,eAAA;EADJ;AACF;AAlDA;;EAsDM,YAAA;AAAN;AAtDA;;EA0DM,YAAA;EACA,qBAAA;AAAN;AA3DA;EAgEI,aAAA;EACA,wBAAA;EACA,sBAAA;EACA,8BAAA;AAFJ;AAjEA;EAsEM,mBAAA;AAFN;AAGM;EAAA;IACE,mBAAA;EAAN;AACF;AAzEA;EA4EM,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAAN;AAEM;EAAA;IACE,kBAAA;EACN;AACF","sourcesContent":["#integration-drawer {\n  .header{\n    padding-left: 5rem;\n    padding-top: 2.5rem;\n\n    @media(max-width: @md-screen) {\n      padding: 1rem;\n      padding-bottom: 0;\n    }\n\n    .close-button {\n      margin-right: 0.65rem;\n    }\n  }\n\n  .list-container {\n    padding: 0 5rem;\n\n    .add-integration-form-left-title{\n      padding: 2.5rem 0;\n\n      @media (max-width: @md-screen) {\n        padding: 2rem 0;\n      }\n    }\n\n    @media(max-width: @md-screen) {\n      padding: 0 1rem;\n    }\n  }\n\n  .carousel-content{\n    overflow-y: auto;\n  }\n\n  .slick-dots{\n    display: none !important;\n  }\n\n  .loading-redirect-screen,\n  .loading-integration-screen {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 0 12.5rem;\n\n    @media (max-width: @md-screen) {\n      padding: 0 2rem;\n    }\n\n    p{\n      opacity: 0.5;\n    }\n\n    .loading-integration-image {\n      width: 12rem;\n      margin-bottom: 3.6rem;\n    }\n  }\n\n  .success-integration-content {\n    height: 100vh;\n    display: flex !important;\n    flex-direction: column;\n    justify-content: space-between;\n\n    .success-integration-message-container {\n      margin-bottom: 96px;\n      @media(max-width: @md-screen) {\n        margin-bottom: 1rem;\n      }\n    }\n    .gyramais-integration-alert {\n      margin: 0 10% 1.5625rem 10%;\n      max-width: 40rem;\n      text-align: center;\n      background-color: #E6F7FF;\n\n      @media (max-width: @md-screen) {\n        margin: 0 0 1rem 0;\n      }\n    }\n  }\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
